module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.inspection.status.typename === 'not_submitted') ? _c('span', {
    staticClass: "label label-default"
  }, [_vm._v("\n        DRAFT\n    ")]) : _vm._e(), _vm._v(" "), (_vm.inspection.status.typename === 'submitted') ? _c('span', {
    staticClass: "label label-info"
  }, [_vm._v("\n        SUBMITTED\n    ")]) : _vm._e(), _vm._v(" "), (_vm.inspection.status.typename === 'validated') ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("\n        APPROVED\n    ")]) : _vm._e(), _vm._v(" "), (_vm.inspection.status.typename === 'rejected') ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("\n        REJECTED\n    ")]) : _vm._e(), _vm._v(" "), (_vm.inspection.status.typename === 'modified') ? _c('span', {
    staticClass: "label label-warning"
  }, [_vm._v("\n        MODIFIED\n    ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46fa07c8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/inspection-status-badge.vue
// module id = 818
// module chunks = 3